import initialState from './accounts.initialState';
import {
  LOAD_ACCOUNT_START,
  LOAD_ACCOUNT_SUCCESS,
  LOAD_ACCOUNT_ERROR,
  UPDATE_ACCOUNT_START,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_RESET,
  UPDATE_ACCOUNT_ERROR,
  CREATE_ACCOUNT_START,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_ERROR,
  CREATE_CCP_ACCOUNT_START,
  CREATE_CCP_ACCOUNT_SUCCESS,
  CREATE_CCP_ACCOUNT_ERROR,
  CREATE_IAM_ACCOUNT_START,
  CREATE_IAM_ACCOUNT_SUCCESS,
  CREATE_IAM_ACCOUNT_ERROR,
} from './accounts.actions';
import { applyByKey } from '../../utils/reducerHelpers';

export default function accountsReducer(state = initialState, action) {
  const { key } = action;
  switch (action.type) {
    case LOAD_ACCOUNT_START:
      return applyByKey(key, state, () => ({
        loading: true,
        error: false
      }));
    case LOAD_ACCOUNT_ERROR:
      return applyByKey(key, state, () => ({
        loading: false,
        value: undefined,
        error: true
      }));
    case LOAD_ACCOUNT_SUCCESS:
    {
      const { data } = action.response;
      return applyByKey(key, state, () => ({
        loading: false,
        error: false,
        carrierAccount: {
          AccountUid: data.AccountUid,
          Id: data.Id,
          LegalName: data.Name,
          FBPN: data.Fbpn,
          CarrierAccounts: data.CarrierAccounts,
          TradeName: data.TradeName,
          Email: data.Email,
          AddressLine: data.Address1,
          AddressLine2: data.Address2,
          PhoneNumber: data.Phone,
          City: data.City,
          State: data.State,
          ZipCode: data.ZipCode,
          HomeState: data.HomeState,
          IsProducer: data.IsProducer,
          IsConfigurationComplete: data.IsConfigurationComplete
        }
      }));
    }

    case UPDATE_ACCOUNT_START:
      return applyByKey(key, state, () => ({
        posting: true,
        error: false
      }));

    case UPDATE_ACCOUNT_SUCCESS:
      return applyByKey(key, state, () => ({
        posting: false,
        error: false
      }));

    case UPDATE_ACCOUNT_ERROR:
      return applyByKey(key, state, () => ({
        posting: false,
        error: true
      }));

    case UPDATE_ACCOUNT_RESET:
      return applyByKey(key, state, () => ({
        posting: undefined,
        error: false
      }));

    case CREATE_ACCOUNT_START:
      return applyByKey(key, state, () => ({
        createAccountStatus: {
          posting: true,
          error: false,
          step: null,
          iam: {
            started: false,
            posting: false,
            error: false
          },
          ccp: {
            started: false,
            posting: false,
            error: false
          }
        }
      }));
    case CREATE_ACCOUNT_ERROR:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        posting: false,
        error: true
      })));
    case CREATE_ACCOUNT_SUCCESS:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        posting: false,
        step: 'complete'
      })));
    case CREATE_CCP_ACCOUNT_START:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        step: 'ccp',
        ccp: {
          started: true,
          posting: true,
          error: false
        }
      })));
    case CREATE_CCP_ACCOUNT_ERROR:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        step: 'ccp',
        ccp: {
          started: true,
          posting: false,
          error: true
        }
      })));
    case CREATE_CCP_ACCOUNT_SUCCESS:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        step: 'ccp',
        ccp: {
          started: true,
          posting: false,
          error: false
        }
      })));
    case CREATE_IAM_ACCOUNT_START:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        step: 'iam',
        iam: {
          started: true,
          posting: true,
          error: false
        }
      })));
    case CREATE_IAM_ACCOUNT_ERROR:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        step: 'iam',
        iam: {
          started: true,
          posting: false,
          error: false
        }
      })));
    case CREATE_IAM_ACCOUNT_SUCCESS:
      return applyByKey(key, state, () => applyByKey('createAccountStatus', state[key], () => ({
        step: 'iam',
        iam: {
          started: true,
          posting: false,
          error: false
        }
      })));

    default:
      return state;
  }
}
